import { ReactNode } from 'react'
import { BRAND } from '../../constants'

const styles = {
  loader: {
    border: `1px solid ${BRAND.primaryColour}`,
    borderRadius: 4,
    backgroundColor: 'transparent',
    padding: '7px 14px',
    color: BRAND.primaryColour,
    cursor: 'pointer',
    margin: 15
  },
  primary: {
    height: 28,
    backgroundColor: BRAND.primaryColour,
    color: 'white',
    fontSize: 12,
    fontWeight: 600,
    padding: '4px 15px',
    cursor: 'pointer',
    borderRadius: 4,
    margin: '0px 15px',
    minWidth: 150
  },

  secondary: {
    height: 25,
    backgroundColor: 'white',
    color: BRAND.primaryColour,
    fontsSize: 12,
    padding: '3px 6px',
    cursor: 'pointer',
    borderRadius: 4,
    maxWidth: '100%'
  },
  link: {
    height: 25,
    fontSize: 16,
    padding: '6px 12px',
    cursor: 'pointer',
    backgroundColor: 'transparent'
  },
  home: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    backgroundColor: 'white',
    color: BRAND.darkGrey,
    cursor: 'pointer',
    borderRadius: 4,
    padding: '6px 18px',
    fontSize: 18,
    fontWeight: 500,
    maxWidth: '100%',
    textDecoration: 'none'
  },
  cta: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    backgroundColor: 'white',
    color: '#262626',
    cursor: 'pointer',
    borderRadius: 4,
    padding: '6px 18px',
    fontSize: 16,
    fontWeight: 500,
    maxWidth: '100%',
    textDecoration: 'none'
  }
} as const

type ButtonLinkProps = {
    primary?: boolean
    secondary?: boolean
    strong?: boolean
    link?:boolean
    children?: ReactNode
    id?: string
    home?: boolean
    width?: number
    href?: string
    cta?: boolean
}

export const ButtonLink = ({ primary, secondary, strong, link, children, id, home, width, href, cta }: ButtonLinkProps) => {
  if (primary)
    return (
      <a id={id} style={{ ...styles.primary, width }} href={href}>
        {children}
      </a>
    )
  if (link) 
    return (
      <a id={id} style={{ ...styles.link, fontWeight: strong ? 'bold' : 400 }} href={href}>
        {children}
      </a>
    )
  if (secondary)
    return (
      <a id={id} style={{ ...styles.secondary, width }} href={href}>
        {children}
      </a>
    )
  if (home)
    return (
      <a tabIndex={0} id={id} href={href} style={{ ...styles.home }}>
        {children}
      </a>
    )
  if (cta)
    return (
      <a tabIndex={0} id={id} href={href} style={{ ...styles.cta }}>
        {children}
      </a>
    )
  return (
    <a id={id} style={styles.loader}>
      {children}
    </a>
  )
}
